import PriceSection from "components/Service/PriceSection";
import HeroTraining from "components/Training/HeroTraining";
import ListTraining from "components/Training/ListTraining";
import QuoteTraining from "components/Training/QuoteTraining";
import MissionTraining from "components/TrainingBusiness/MissionTraining";
import React, { useEffect } from "react";
import BookSection from "components/Events/BookSection";
import { useLocation } from "react-router-dom";

const Training = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      {/* <HeroTraining /> */}
      <MissionTraining />

      <QuoteTraining />
      <div id="trainning">
        <ListTraining />
      </div>
      <BookSection />
    </div>
  );
};

export default Training;
